module.exports = __webpack_public_path__ + "3391f0733de9e01f05174231a05307da.png";